import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import $t from '../../../i18n'
import config from '../../../config.json'
import dayjs from 'dayjs'
import {
  getQueueAppointment,
  getPendingAppointment,
} from '../../../utils/appointmentsUtils'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { Button } from 'antd'

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

// this component return text with time formatted - eta/pending appointment slot
export const TimeSlotMessage = ({ className, displayOnlyTime }) => {
  const dispatch = useDispatch()

  const appointments = useSelector(state => state.appointments?.appointments)
  const eta = useSelector(state => state.appointments?.eta)

  const pendingAppointment = getPendingAppointment(appointments)
  const queueAppointment = getQueueAppointment(appointments)

  const isAppointmentInQueue = !!queueAppointment
  const isPendingAppointment = !!pendingAppointment

  // the expire time from BE - it is null when there is no appointment/When the time is expired
  const appointmentTimeLeft = useSelector(
    state => state.appointments.appointmentTimeLeft
  )

  // the time left is calculated per seconds/minutes
  // depends if its queue appointment or pending
  //
  const [timeLeft, setTimeLeft] = useState(
    appointmentTimeLeft?.diff(dayjs(), 'seconds')
  )
  const [timeLeftInHours, setTimeLeftInHours] = useState(null)
  const [timeLeftInDays, setTimeLeftInDays] = useState(null)
  const [counterInterval, setCounterInterval] = useState(null)

  const loadingIcon = (
    <LoadingOutlined
      style={{
        fontSize: 15,
        color: 'var(--color_primary_t500)',
      }}
      spin
    />
  )

  const onTimerPress = () => {
    const appointment = isPendingAppointment
      ? pendingAppointment
      : queueAppointment
    dispatch(
      Actions.createAction(Actions.SELECTED_APPOINTMENT_CHANGED, appointment)
    )
  }

  const onInterval = () => {
    const now = dayjs().utc()
    setTimeLeft(appointmentTimeLeft?.diff(now, 'seconds'))
    setTimeLeftInHours(appointmentTimeLeft?.diff(now, 'hours'))
    setTimeLeftInDays(appointmentTimeLeft?.diff(now, 'days'))
  }

  useEffect(() => {
    // go in just when appointmentTimeLeft changes and exist
    if (appointmentTimeLeft) {
      // eta should tick every minute, while pending appointment should tick every second
      const durationTick = isPendingAppointment ? 1000 : 60000
      const interval = setInterval(onInterval, durationTick)
      setCounterInterval(interval)
      return () => clearInterval(interval)
      // clear interval when appointmentTimeLeft is null (when expired)
    } else if (!appointmentTimeLeft && counterInterval) {
      clearInterval(counterInterval)
      setCounterInterval(null)
    }
  }, [appointmentTimeLeft])

  useEffect(() => {
    // check if we have appointmentTimeLeft and if the time left is 0 or below
    // note - not sure why the parse in here?!?
    //(explnation that was writen before about it - in case we remove this condition, we will have more than 1 action dispatch when timer left)
    if (appointmentTimeLeft && timeLeft <= parseInt('0', 10)) {
      dispatch(
        Actions.createAction(
          isPendingAppointment ? Actions.SLOT_EXPIRED : Actions.SLOT_CLEARED
        )
      )
      dispatch(Actions.createAction(Actions.APPOINTMENTS_POLL_REQUESTED))
    }
  }, [timeLeft])

  const timerElement = () => {
    let midnight = dayjs()
      .utcOffset(0)
      .set('hour', 0)
      .set('minute', 0)
      .set('second', 0)
      .set('millisecond', 0)
    let duration
    let duration_unit
    if (timeLeftInDays > 0) {
      duration = timeLeftInDays
      duration_unit = 'notifications.durationDays'
    } else if (timeLeftInHours > 0) {
      duration = timeLeftInHours
      duration_unit = 'notifications.durationHours'
    } else {
      duration = midnight
        .add(timeLeft, 'seconds')
        .format(isPendingAppointment ? config.timerFormat : 'm')
      duration_unit = 'notifications.durationMinutes'
    }

    // textId is the translation id of the require text (should include {time} param)
    const textId = isPendingAppointment
      ? 'notifications.pendingAppointment'
      : 'notifications.eta'

    return (
      <span
        onClick={onTimerPress}
        style={{ cursor: 'pointer' }}
        className={className + ' trackable'}
        data-name="time-slot-message"
      >
        {!displayOnlyTime && !isPendingAppointment && (
          <i className="icon-watch" />
        )}
        {displayOnlyTime
          ? duration + ' ' + $t(duration_unit)
          : $t(textId) + duration + ' ' + $t(duration_unit)}
        {!displayOnlyTime && (
          <Button className="timer-btn" onClick={onTimerPress}>
            {isPendingAppointment ? $t('common.pay') : $t('common.moreInfo')}
          </Button>
        )}
      </span>
    )
  }

  const renderTimerIfneeded = () => {
    if (timeLeft) return timerElement()
    // in case there is eta and the timeleft is 0, replace the text to 'anyminute now' (not relevant for pending)
    if (!timeLeft && !!eta && !isPendingAppointment && isAppointmentInQueue)
      return (
        <span
          className={'any-minute ' + className + ' trackable'}
          data-name="time-slot-message"
          style={{ cursor: 'pointer' }}
          onClick={onTimerPress}
        >
          {$t('common.anyMinuteNow')}
        </span>
      )
    if ((isPendingAppointment && !timeLeft) || (isAppointmentInQueue && !eta))
      return <Spin indicator={loadingIcon} />
    else return null
  }

  return renderTimerIfneeded()
}

export default TimeSlotMessage
